import { z } from "zod";
import { ImportLicenseRequiredEnum } from "@/constants/enums/importLicenseRequired.enum";
import { IdentityDocumentRequiredEnum } from "@/constants/enums/identityDocumentRequired.enum";
import { GetCustomPolicyDto } from "@/types/api/api-types";

export const CustomPolicyFormSchema = z.object({
  maxBottles: z.boolean(),
  maxBottlesValue: z.number().int().nonnegative(),
  maxLiters: z.boolean(),
  maxLitersValue: z.number().nonnegative(),
  maxPurchase: z.boolean(),
  maxPurchaseValue: z.number().int().nonnegative(),
  maxPurchaseCurrency: z.string().min(1),
  maxAlcoholPercentage: z.boolean(),
  maxAlcoholPercentageValue: z.number().nonnegative(),

  divideShipmentOverDays: z.boolean(),
  dapOnly: z.boolean(),
  noShipmentToPrivateIndividual: z.boolean(),
  sampleOnly: z.boolean(),
  freightAvailable: z.boolean(),

  importLicenseRequired: z.nativeEnum(ImportLicenseRequiredEnum),
  originCertificateRequired: z.boolean(),
  powerOfAttorneyRequired: z.boolean(),
  identityDocumentRequired: z.nativeEnum(IdentityDocumentRequiredEnum),
  otherRequiredDocuments: z.array(z.string()),

  notes: z.string().optional().nullable(),
  procedure: z.string().optional().nullable(),
});

export type CustomPolicyFormData = z.infer<typeof CustomPolicyFormSchema>;

export const mapPolicyToFormData = (policy: GetCustomPolicyDto): CustomPolicyFormData => ({
  maxBottles: policy.maxBottles,
  maxBottlesValue: policy.maxBottlesValue,
  maxLiters: policy.maxLiters,
  maxLitersValue: policy.maxLitersValue,
  maxPurchase: policy.maxPurchase,
  maxPurchaseValue: policy.maxPurchaseValue,
  maxPurchaseCurrency: policy.maxPurchaseCurrency,
  maxAlcoholPercentage: policy.maxAlcoholPercentage,
  maxAlcoholPercentageValue: policy.maxAlcoholPercentageValue,
  divideShipmentOverDays: policy.divideShipmentOverDays,
  dapOnly: policy.dapOnly,
  noShipmentToPrivateIndividual: policy.noShipmentToPrivateIndividual,
  sampleOnly: policy.sampleOnly,
  freightAvailable: policy.freightAvailable,
  importLicenseRequired: policy.importLicenseRequired as ImportLicenseRequiredEnum,
  originCertificateRequired: policy.originCertificateRequired,
  powerOfAttorneyRequired: policy.powerOfAttorneyRequired,
  identityDocumentRequired: policy.identityDocumentRequired as IdentityDocumentRequiredEnum,
  otherRequiredDocuments: policy.otherRequiredDocuments,
  notes: (policy.notes as unknown as string | null) ?? undefined,
  procedure: (policy.procedure as unknown as string | null) ?? undefined,
});
